import { handleMultilingualPrefix, isProtectedEnvironment } from '@/utils/domainUtils';
import { APP_CONFIGURATION_ROUTE } from '@/constants/routes.constants';
import type { MieleApiErrorResponse } from './miele-api-service';
import type { ConfigurationResponse } from '@/types/shared-types';

const PREPEND_AUTH_KEY = '368244dd91850e0647d36515b6076b288b94663aaed15a554b5721ee04ce2244';

export const getAppConfiguration = async (baseUrl?: string): Promise<ConfigurationResponse> => {
    const hostname = import.meta.env.VITE_HYBRIS_HOST
        ? import.meta.env.VITE_HYBRIS_HOST
        : baseUrl
            ? baseUrl
            : window.location.origin;
    const fetchUrl = handleMultilingualPrefix(APP_CONFIGURATION_ROUTE);
    const extraHeaders = isProtectedEnvironment(hostname) ? { authKey: PREPEND_AUTH_KEY } : {} as Headers
    const response = await fetch(`${hostname}${fetchUrl}`, { headers: extraHeaders });
    const data = await response.json();

    if (!response.ok) {
        console.error('Unable to load VG global configuration.');
        throw new Error((data as MieleApiErrorResponse).data);
    }

    return data;
};
